/* eslint-disable no-restricted-syntax */
export const ENDPOINT_TRANSLATION = '/locales/en/translation.json'
export const URL_APL_REGISTRATION = `${
  import.meta.env.VITE_FRONTEND_HTTPS_ONBOARDING
}/page/simple-partner-registration`

export const URL_PROFILING_TICKETS = `${
  import.meta.env.VITE_FRONTEND_HTTPS_ONBOARDING
}/page/profiling-tickets`

export const ENDPOINT_EXPORT_SPR = `${import.meta.env.VITE_HTTPS_ONBOARDING}/api/v0/export/spr`
export const ENDPOINT_EXPORT_TEMPLATES = `${
  import.meta.env.VITE_HTTPS_ONBOARDING
}/api/v0/export/templates`
export const ENDPOINT_IMPORT_TEMPLATES = `${
  import.meta.env.VITE_HTTPS_ONBOARDING
}/api/v0/Import/templates`
export const ENDPOINT_EXECUTE_TRANSITION_BY_TOKEN = `${
  import.meta.env.VITE_HTTPS_ONBOARDING
}/api/v0/executeTransitionByToken`
export const URL_BP_REGISTRATION = '/page/bp-registration'
export const URL_BP_REGISTRATION_GUIDE =
  'https://app-designer.hpcloud.hp.com/builder/rs/forms/1161/images/BP/Business%20Partner%20List%20Registration%20guide.pdf'
export const URL_BP_TROUBLESHOOT_GUIDE =
  'https://app-designer.hpcloud.hp.com/builder/rs/forms/1161/images/BP/BP%20Registration%20troubleshoot.pdf'
export const URL_APL_REGISTRATION_GUIDE =
  'https://app-designer.hpcloud.hp.com/builder/rs/forms/1161/images/spr/Authorized%20Partner%20List%20Registration%20guide.pdf'
export const URL_APL_TROUBLESHOOT_GUIDE =
  'https://app-designer.hpcloud.hp.com/builder/rs/forms/1161/images/spr/APL%20troubleshoot%20guide.pdf'
export const URL_ACTIVE_EVENT_PLANNER = `https://${
  import.meta.env.VITE_RFB_URL
}/designer/apps/event-planner/pages/planner-page"`
export const ENDPOINT_EXPORT_NON_ELIGIBLE_PARTNER_LIST = `${
  import.meta.env.VITE_HTTPS_ONBOARDING
}/api/v0/export/non_eligible_partner_list`
export const ENDPOINT_EXPORT_APL_AMS_ELIGIBLE_PARTNER_LIST = `${
  import.meta.env.VITE_HTTPS_ONBOARDING
}/api/v0/export/apl/ams/eligible_partner_list`
export const ENDPOINT_EXPORT_APL_AMS_LATAM_ELIGIBLE_PARTNER_LIST = `${
  import.meta.env.VITE_HTTPS_ONBOARDING
}/api/v0/export/apl/ams-latam/eligible_partner_list`

/**
 * @deprecated Legacy per-type upload endpoint. All uploadable types now POST to
 * the unified `PUT /api/v0/upload/:type` (see ENDPOINT_UPLOAD_UNIFIED_BASE and
 * resolveUploadEndpoint). Kept only as the migration fallback.
 * TODO: Replace with unified and remove code.
 */
export const ENDPOINT_UPLOAD_NON_ELIGIBLE_PARTNER_LIST =
  '/api/v0/upload/apl/non-eligible-partner-list'

/** @deprecated See ENDPOINT_UPLOAD_NON_ELIGIBLE_PARTNER_LIST. TODO: Replace with unified and remove code. */
export const ENDPOINT_UPLOAD_APL = '/api/v0/upload/apl/import'
/** @deprecated See ENDPOINT_UPLOAD_NON_ELIGIBLE_PARTNER_LIST. TODO: Replace with unified and remove code. */
export const ENDPOINT_UPLOAD_APL_AMS = '/api/v0/apl/ams/upload'
/** @deprecated See ENDPOINT_UPLOAD_NON_ELIGIBLE_PARTNER_LIST. TODO: Replace with unified and remove code. */
export const ENDPOINT_UPLOAD_APL_MAP = '/api/v0/apl/map/upload'

/**
 * Unified upload endpoint base — `PUT /api/v0/upload/:type` (plan §4.5). The type
 * segment is the OnboardingUploadType enum VALUE (equals the backend EUploadType
 * value). Types migrate off their legacy per-type endpoint one at a time; see
 * resolveUploadEndpoint.
 */
export const ENDPOINT_UPLOAD_UNIFIED_BASE = '/api/v0/upload'
